"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {
            position: "relative",
            width: 200,
            minWidth: 200,
            height: 250,
            minHeight: 250,
            marginLeft: 16,
            marginTop: 16,
            marginBottom: 16,
            backgroundColor: theme.palette.white,
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.05)",
            transition: "box-shadow 0.5s, border 0.5s",
            border: "1px solid " + theme.palette.neutralQuaternary,
            selectors: {
                "&:hover": {
                    boxShadow: "0 5px 30px rgba(0, 0, 0, 0.15)",
                    selectors: {
                        ".opacity-hover": {
                            opacity: 0.4
                        }
                    }
                },
                "&:focus": {
                    boxShadow: "0 5px 30px rgba(0, 0, 0, 0.15)"
                }
            }
        },
        clickableRoot: {
            cursor: "pointer"
        },
        top: {
            height: 52,
            width: "100%",
            opacity: 0.1,
            transition: "opacity 0.25s",
            overflow: "hidden",
            backgroundColor: theme.palette.themeDark
        },
        thumbnail: {
            position: "absolute",
            left: 10,
            top: 10,
            width: 32,
            height: 32,
            zIndex: 2,
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            selectors: {
                "&.is-icon": {
                    backgroundColor: theme.palette.themeDark,
                    color: theme.palette.white
                }
            }
        },
        content: {
            position: "absolute",
            top: 52,
            left: 0,
            right: 0,
            bottom: 44,
            color: theme.palette.neutralPrimary,
            fontSize: styling_1.FontSizes.small
        },
        title: {
            fontWeight: styling_1.FontWeights.semibold,
            fontSize: styling_1.FontSizes.icon,
            paddingTop: 12,
            paddingRight: 10,
            paddingBottom: 6,
            paddingLeft: 10,
            marginTop: 0,
            marginBottom: 0
        },
        shortDescription: {
            fontWeight: styling_1.FontWeights.light,
            overflow: "hidden",
            textOverflow: "clip",
            maxHeight: 60,
            paddingTop: 0,
            paddingRight: 10,
            paddingBottom: 2,
            paddingLeft: 10,
            marginTop: 0,
            marginBottom: 0
        },
        footer: {
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            height: 44,
            borderTop: "1px solid " + theme.palette.neutralLighter,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly"
        }
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
